import RichText from 'components/rich-text/RichText';
import Link from 'components/link/Link';
import Heading from 'components/heading/Heading';

import { IButtonInfoBlock } from 'source/NFR.types';

const ButtonInfoBlock: React.FC<IButtonInfoBlock> = ({ onPageEditing, title, text, buttonText, buttonTarget }) => {
  return (
    <div className="button-info-block">
      {title && (
        <div className="button-info-block--header">
          <Heading className="button-info-block--header-title" onPageEditing={onPageEditing?.title}>
            {title}
          </Heading>
        </div>
      )}

      {text && <RichText className="button-info-block--text" {...text} />}
      <Link
        className="info-block--cta-button"
        theme={['primary', 'large']}
        url={buttonTarget}
        useButtonStyles
        openInNewWindow
      >
        {buttonText}
      </Link>
    </div>
  );
};

ButtonInfoBlock.displayName = 'ButtonInfoBlock';

export default ButtonInfoBlock;
